import { useTranslation } from "react-i18next";

import { MaterialItemFragment } from "../../../../../../../models/autogenerated-deliveryService-gql/graphql";
import "./DetailsPopoverItem.scss";
import DetailsPopoverItemProperty from "./detailsPopoverItemsProperty/DetailsPopoverItemProperty";

interface DetailsPopoverItemMaterialProps {
  item: MaterialItemFragment;
}

const DetailsPopoverItemMaterial = (props: DetailsPopoverItemMaterialProps) => {
  const { t } = useTranslation();
  const { item } = props;

  return (
    <div className="details-item-container" key={item.id}>
      <DetailsPopoverItemProperty
        label={t("materialName")}
        value={item.materialResolved?.name}
      />
      <DetailsPopoverItemProperty label={t("position")} value={item.number} />
      <DetailsPopoverItemProperty
        label={t("classification")}
        value={item.category}
      />
      <DetailsPopoverItemProperty
        label={t("batch")}
        value={item.batchResolved?.map((b) => b?.name).join(", ")}
      />
      <DetailsPopoverItemProperty
        label={t("stockType")}
        value={item.stockTypeResolved?.longName}
      />
      <DetailsPopoverItemProperty
        label={t("requestedQuantity")}
        value={item.requestedQuantity}
      />
      <DetailsPopoverItemProperty
        label={t("openQuantity")}
        value={item.openQuantity}
      />
      <DetailsPopoverItemProperty
        label={t("executedQuantity")}
        value={item.executedQuantity}
      />
      <DetailsPopoverItemProperty
        label={t("unit")}
        value={item.unitOfMeasurementResolved?.unitOfMeasurement}
      />
      <div className="page-content-divider" />
    </div>
  );
};

export default DetailsPopoverItemMaterial;
